/**
 * Language resource for validation messages.
 * @typedef {Object} ValidationMessages
 * @property {string} documentTypeRequired - Validation message for the document type field when it's empty.
 * @property {string} subjectValid - Validation message for the subject field when it's not valid.
 * @property {string} messageValid - Validation message for the message field when it's not valid.
 */

/**
 * Language resource for validation messages.
 * @type {ValidationMessages}
 */
export const validation = {
  documentTypeRequired: "Please enter a reason",
  subjectValid: "Please enter the subject",
  messageValid: "Please enter the message",
};
